import React from 'react';

/** This component is a placeholder for formatting inside CardsList */
var NarrowCardPlaceholder = function NarrowCardPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "presentation-card presentation-card-narrow card-placeholder"
  });
};
NarrowCardPlaceholder.displayName = "NarrowCardPlaceholder";
export { NarrowCardPlaceholder };